import instance from "./BasebMetaApi";

export function getMetaStatus(organisationId, locationId = null, brandId = null) {
  return instance.request({
    url: `status/?organisation_id=${organisationId}${locationId ? `&location_id=${locationId}` : ''}${brandId ? `&brand_id=${brandId}` : ''}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function activateMetaIntegration(data) {
  return instance.request({
    url: `activate-meta/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function getMetaConfigs(organisationId) {
  return instance.request({
    url: `configs/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function deactivateMetaIntegration(data) {
  return instance.request({
    url: `deactivate-meta/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}
